import ICMAxios from "../ICMAxios";

const fetchUserById = async (userId: any) => {
  const response = await ICMAxios.get(`v1/User/${userId}/userdetails`);
  return response.data;
};

const changePassword = async (data: any) => {
  const response = await ICMAxios.post(`v1/User`, data);
  return response.data;
};
const updateProfile = async (data: any) => {
  const response = await ICMAxios.post(`v1/User/updateprofile`, data);
  return response.data;
};

const generateQrCode = async () => {
  const response = await ICMAxios.get(
    `v1/User/generateclientQRcode`
  );
  return response.data;
};
const signUp = async (data: any) => {
  const response = await ICMAxios.post(`v1/User/signup`, data);
  return response.data;
};
// Get User List By Client
const getUserList = async (payload: any) => {
  const response = await ICMAxios.post(`v1/User/userlist`, payload);
  return response.data;
};
// Update user status
const updateUserStatus = async (payload: any) => {
  const response = await ICMAxios.put(`v1/User/status`, payload);
  return response.data;
};
// Update user role
const updateUserRole = async (payload: any) => {
  const response = await ICMAxios.put(`v1/User/role`, payload);
  return response.data;
};
// Send Forgot Password Email
const sendForgotPasswordEmail = async (payload: any) => {
  const response = await ICMAxios.post(
    `v1/User/sendforgotpasswordemail`,
    payload
  );
  return response.data;
};
const forgotPassword = async (data: any) => {
  const response = await ICMAxios.put(`v1/User/forgotpassword`, data);
  return response.data;
};
const getUserDropDown = async () => {
  const response = await ICMAxios.get(`v1/User/getUsersWithSpecificRolesByClient`);
  return response.data;
};
const userService = {
  forgotPassword,
  sendForgotPasswordEmail,
  fetchUserById,
  changePassword,
  updateProfile,
  generateQrCode,
  signUp,
  getUserList,
  updateUserStatus,
  updateUserRole,
  getUserDropDown
};
export default userService;
